import { default as notifications } from './notifications';
import { default as routes } from './routes';

export default {
    ...notifications,
    ...routes
};
